module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "header-orders rel",
    attrs: {
      "id": "header-orders"
    }
  }, [_c('div', {
    staticClass: "header-bloc row"
  }, [_c('div', {
    staticClass: "header-title col-lg-6 col-md-6 col-xs-12"
  }, [_c('h1', [_c('span', {
    staticClass: "roundedIcon",
    class: {
      orderWindowActive: _vm.order.countdown != null
    },
    attrs: {
      "id": 'orderWindowIcon'
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-alt fa-lg"
  })]), _vm._v(" "), (_vm.order.countdown != null) ? _c('b-tooltip', {
    attrs: {
      "container": "header-orders",
      "target": 'orderWindowIcon',
      "placement": 'right'
    }
  }, [_c('div', {
    staticClass: "orderWindowInfoToolTip"
  }, [_c('span', [_vm._v(_vm._s(_vm.order.countdown.name))])])]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.$t("orders.title")) + " " + _vm._s(_vm.order.reference) + "\n                ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-actions col-lg-6 col-md-6 col-xs-12"
  }, [_c('button', {
    staticClass: "btn-orders btn-print"
  }, [_vm._v(_vm._s(_vm.$t("orders.btnOrders.btnPrint")))]), _vm._v(" "), (_vm.hasDiamAdminRights && _vm.order.status.reference_status !== 'order_shipped') ? _c('button', {
    staticClass: "btn-orders btn-cancel",
    on: {
      "click": function($event) {
        _vm.deleteOrder()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("orders.btnOrders.btnCancel")) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-orders btn-archive"
  }, [_vm._v(_vm._s(_vm.$t("orders.btnOrders.btnArchive")))])])]), _vm._v(" "), _c('div', {
    staticClass: "header-date"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "orders-created col-md-6 col-xs-12"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("orders.labelCreated")) + " " + _vm._s(_vm.order.createdAt) + " " + _vm._s(_vm.$t("orders.labelCreatedBy")) + " " + _vm._s(_vm.fullNameFormat(_vm.order.createdBy)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "orders-update col-md-6 col-xs-12"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("orders.labelLastUpdate")) + " " + _vm._s(_vm.order.modifiedDate) + " " + _vm._s(_vm.$t("orders.labelLastUpdateBy")) + "\n                    " + _vm._s(_vm.fullNameFormat(_vm.order.modifiedBy)) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-198e5011","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/order-header.vue
// module id = 3045
// module chunks = 0